import React, { Component, Fragment } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";
import clsx from "clsx";
import Button from "@material-ui/core/Button";
import { withRouter } from "react-router-dom";
import Avatar from "@material-ui/core/Avatar";
import { withStyles } from "@material-ui/styles";
import {
  routeState,
  FormStore,
  publishedFormState,
} from "../services/form.store";
import AlertDialog from "../components/form-element/AlertDialog";
import { ALERT_DIALOGS } from "../services/form.helper.service";
import FormBuilderService from "../services/form-builder.service";
import { currentUserState } from "../services/session.manager";
// import NotificationsNoneOutlined from "@material-ui/icons/NotificationsNoneOutlined";
// import PeopleIcon from "@material-ui/icons/People";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import Menu from "@material-ui/core/Menu";
import { logoutAndRedirect } from "../services/auth.service";
import { roles } from "../utility/Constant";

import { UserInfoService } from "../services/user-info.service";
import { SessionManager } from "../services/session.manager";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    boxShadow: "none",
  },
  flexGrow: {
    flexGrow: 1,
  },
  navLink: {
    padding: "20px",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  tmp: {
    border: "red",
  },
  formLabel: {
    fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
    fontSize: "24px",
  },
  imgStyle: {
    margin: "1%",
  },
  header: {
    display: "flex",
    padding: "16px",
    alignItems: "center",
  },
  avatar: {
    flex: "0 0 auto",
    marginRight: "16px",
    width: "50px",
    height: "50px",
  },
  headerContent: {
    flex: "1 1 auto",
    color: "#419BAC",
  },
  title: {
    display: "block",
  },
  subtitle: {
    marginTop: "7px",
    color: "black",
  },
  actions: {
    backgroundColor: "#f6f6f6",
    top: "auto",
    position: "relative",
    width: "100%",
  },
  logout: {
    border: "2px solid #419BAC",
    color: "#419BAC",
  },
  activeButton: {
    backgroundColor: "#363F4F",
    padding: "20px",
  },
});

const FIELDWORK_TEAMS_LINK =
  "https://teams.microsoft.com/l/channel/19%3A57bed3b94778473e9231fe8c3c0b76e2%40thread.tacv2/FieldWork%20User%20Resources?groupId=5a086032-2bdc-4dcd-8b65-d203648c6cb2&tenantId=15ccb6d1-d335-4996-b6f9-7b6925f08121";

class Header extends Component {
  constructor() {
    super();
    this.state = {
      edited: false,
      showAlert: false,
      currentUrl: window.location.pathname,
      anchorEl: null,
      userName: "",
      user: {},
      showLogoutConfirmation: false,
      isReview: window.location.pathname === "/review" ? true : false,
      isFormLatest: true,
    };
    this.formBuilderService = new FormBuilderService();
    this.userInfoService = new UserInfoService();
  }

  componentDidMount() {
    this.routerSubscription = routeState.subscribe((isEdited) => {
      this.setState({ edited: isEdited });
    });
    this.currentUserSubscription = currentUserState.subscribe((user) => {
      this.setState({ user: user });
    });
    this.publishedFormSubscription = publishedFormState.subscribe(
      (isLastUpdatedVersion) => {
        this.setState({
          isFormLatest: isLastUpdatedVersion,
        });
      },
    );
    this.setState({ currentUrl: this.props.location.pathname });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({ currentUrl: this.props.location.pathname });
    }
  }

  componentWillUnmount() {
    this.routerSubscription.unsubscribe();
    this.currentUserSubscription.unsubscribe();
  }

  handleHelpRedirect = () => {
    window.open(FIELDWORK_TEAMS_LINK);
  };

  navLink = (url) => {
    this.setState({
      currentUrl: url,
    });
    const { history } = this.props;
    if (this.state.edited && this.state.isFormLatest) {
      this.setState({
        showAlert: true,
      });
    } else {
      history.push(url);
    }
  };

  handleAccountOpen = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  handleAccountClose = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleClose = () => {
    this.setState({
      showAlert: false,
      showLogoutConfirmation: false,
      anchorEl: null,
    });
  };

  handleOk = () => {
    const { history } = this.props;
    history.push(this.state.currentUrl);
    this.setState({
      showAlert: false,
    });
    FormStore.sharedInstance().shouldNavigate(false);
  };

  handleLogout = () => {
    this.setState({
      showLogoutConfirmation: true,
    });
  };

  handleConfirmLogout = async () => {
    this.setState({
      showAlert: false,
      showLogoutConfirmation: false,
      anchorEl: null,
    });
    await logoutAndRedirect();
  };

  handleUsersNavigation = () => {
    const currentUserSSO = localStorage.getItem("ge_sso");
    this.userInfoService.getUserInfo(currentUserSSO).then((response) => {
      if (response?.userRole === "FORMAUTHOR") {
        localStorage.setItem("user_role", response.userRole);
        SessionManager.sharedInstance().updateCurrentUser(response);
        this.props.history.push("/accessDenied");
      } else {
        this.navLink("/users");
      }
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        <AppBar className={classes.root} color="secondary">
          <Toolbar>
            <Typography className={classes.formLabel} variant="inherit">
              NextGen FieldWork
            </Typography>
            {this.props.userRole === "ASSETMANAGER" ? (
              <Typography className={classes.formLabel} variant="inherit">
                NextGen FieldWork - Assets
              </Typography>
            ) : null}
            <div className={classes.flexGrow} />
            {this.props.userRole === "GLOBALADMIN" ||
              this.props.userRole?.toUpperCase() === "FORMAUTHOR" ||
              this.props.userRole?.toUpperCase() === "ASSETMANAGER" ? (
              <>
                {
                  this.props.userRole?.toUpperCase() !== "ASSETMANAGER" ? (
                    <>
                      <Button
                        id="newFormButton"
                        className={clsx(classes.navLink, {
                          [classes.activeButton]:
                            this.state.currentUrl === "/createForm",
                        })}
                        color="inherit"
                        onClick={() => this.navLink("/createForm")}
                      >
                        New Form
                      </Button>
                      <Button
                        id="existingFormsButton"
                        className={clsx(classes.navLink, {
                          [classes.activeButton]:
                            this.state.currentUrl === "/existingForms",
                        })}
                        color="inherit"
                        onClick={() => this.navLink("/existingForms")}
                      >
                        Existing Forms
                      </Button>
                      <Button
                        id="userGroupButton"
                        className={clsx(classes.navLink, {
                          [classes.activeButton]:
                            this.state.currentUrl === "/usergroup",
                        })}
                        color="inherit"
                        onClick={() => this.navLink("/usergroup")}
                      >
                        User Group
                      </Button>
                      {
                        this.props.userRole?.toUpperCase() !== "FORMAUTHOR" ? (
                          <Button
                            id="userManagementButton"
                            className={clsx(classes.navLink, {
                              [classes.activeButton]: this.state.currentUrl === "/users",
                            })}
                            color="inherit"
                            // onClick={() => this.navLink("/users")}
                            onClick={this.handleUsersNavigation}
                          >
                            Users
                          </Button>
                        )
                          :
                          null
                      }
                    </>
                  )
                    : null
                }
                <Button
                  id="assetsButton"
                  className={clsx(classes.navLink, {
                    [classes.activeButton]: this.state.currentUrl === "/assets",
                  })}
                  color="inherit"
                  onClick={() => this.navLink("/assets")}
                >
                  Assets
                </Button>
                <Button
                  id="reviewButton"
                  className={clsx(classes.navLink, {
                    [classes.activeButton]: this.state.currentUrl === "/review",
                  })}
                  color="inherit"
                  onClick={() => this.navLink("/review")}
                >
                  Review
                </Button>
              </>
            ) : null}

            {this.props.userRole === "GLOBALADMIN" ||
              this.props.userRole === "SITEMANAGER" ? (
              <Fragment>
                {/* Notification and People icons removed as per recent UI update.
                Uncomment below if they need to be added back. */}
                {/* <IconButton onClick={this.clearSelected} color="inherit">
                  <NotificationsNoneOutlined fontSize="inherit" />
                </IconButton>
                <IconButton onClick={this.clearSelected} color="inherit">
                  <PeopleIcon fontSize="inherit" />
                </IconButton> */}
                <IconButton onClick={this.handleHelpRedirect} color="inherit">
                  <HelpOutlineIcon fontSize="inherit" />
                </IconButton>
              </Fragment>
            ) : null}
            {this.state.user.email ? (
              <Tooltip title={this.state.user.email}>
                <IconButton
                  id="profileImageIcon"
                  edge="end"
                  color="inherit"
                  aria-label="profile-menu"
                  onClick={this.handleAccountOpen}
                >
                  <Avatar id="avatar" alt="Profile Image" src="" />
                </IconButton>
              </Tooltip>
            ) : null}
          </Toolbar>
          {this.state.showAlert ? (
            <AlertDialog
              id="alertDialog"
              open={this.state.showAlert}
              onClose={this.handleClose}
              handleOk={this.handleOk}
              dialogTitle={ALERT_DIALOGS.UNSAVED_CHANGES_TITLE}
              dialogContent={ALERT_DIALOGS.UNSAVED_CHANGES_CONTENT}
              cancelButton={ALERT_DIALOGS.UNSAVED_CHANGES_CANCEL}
              confirmButton={ALERT_DIALOGS.UNSAVED_CHANGES_CONFIRM}
            />
          ) : null}
        </AppBar>
        <Menu
          anchorEl={this.state.anchorEl}
          keepMounted
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleAccountClose}
          MenuListProps={{ disablePadding: true }}
        >
          <div className={classes.header}>
            <Avatar className={classes.avatar}></Avatar>
            <div className={classes.headerContent}>
              <span className={classes.title}>
                {this.state.user.userFirstName +
                  " " +
                  this.state.user.userLastName}
              </span>
              <span className={classes.title}>{this.state.user.sso}</span>
              <div className={classes.subtitle}>
                {roles
                  ?.find((role) => role?.roleId === this.state.user.userRole)
                  ?.roleName?.toUpperCase()}
              </div>
            </div>
          </div>
          <Toolbar className={classes.actions}>
            <span className={classes.flexGrow} />
            <Button
              onClick={this.handleLogout}
              color="secondary"
              variant="outlined"
              size="small"
            >
              LOGOUT
            </Button>
          </Toolbar>
        </Menu>
        {this.state.showLogoutConfirmation ? (
          <AlertDialog
            open={this.state.showLogoutConfirmation}
            onClose={this.handleClose}
            handleOk={this.handleConfirmLogout}
            dialogTitle={ALERT_DIALOGS.LOGOUT_TITLE}
            dialogContent={ALERT_DIALOGS.LOGOUT_CONTENT}
            cancelButton={ALERT_DIALOGS.LOGOUT_CANCEL}
            confirmButton={ALERT_DIALOGS.LOGOUT_CONFIRM}
          />
        ) : null}
      </Fragment>
    );
  }
}

export default withRouter(withStyles(styles)(Header));
